(function(angular){
'use strict';

class UnsubscribeBadge {
    constructor($translate){
        this.badgeText = $translate.instant('Unsubscribed');
        this.tooltipText = $translate.instant('icm-web__unsubscribe-badge--tooltip');
    }
}

angular
    .module('MW.Influecners.UnsubscribeBadge', ['ngMaterial', 'mwAppComponents'])
    .component('unsubscribeBadge', {
        controller: ['$translate', UnsubscribeBadge],
        template: `
            <span>{{$ctrl.badgeText}}</span>
            <md-tooltip md-direction="top">
                {{$ctrl.tooltipText}}
            </md-tooltip>
        `
    });

})(window.angular);